import * as React from "react";
import LocalStorageService from "../../service/LocalStorageService";
import { Observation } from "../../api/StudyApi";

interface BadgeProps {
  obs?: Observation;
  color?: string;
  text?: string;
}

interface BadgeState {}

export default class ObsBadge extends React.Component<BadgeProps, BadgeState> {
  render() {
    let style: any = {},
      text,
      regionNb,
      state;

    if (this.props.obs) {
      const ot = LocalStorageService.getObservationType(this.props.obs.type);

      if (ot && ot.color) style.backgroundColor = ot.color;

      text = this.props.obs.type;
      regionNb = this.props.obs.regions.length;
      state = this.props.obs.state;

      if (this.props.obs.cardinality <= 0) {
        style.textDecoration = "line-through";
      }
    } else {
      style.backgroundColor = this.props.color;
      text = this.props.text;
    }

    return (
      <span className="badge badge-secondary" style={style}>
        <strong>{text}</strong>

        {regionNb && <span>&nbsp;({regionNb})</span>}

        {state === "validated" && (
          <span>
            &nbsp;
            <i className="fa fa-check" />
          </span>
        )}

        {state === "proposal" && (
          <span>
            &nbsp;
            <i className="fa fa-tag" />
          </span>
        )}

        {state === "doubt" && (
          <span>
            &nbsp;
            <i className="fa fa-question" />
          </span>
        )}
      </span>
    );
  }
}
